module.exports = __webpack_public_path__ + "icon-180x180.png";